import React from 'react'

export const MyChoice = () => {
  return (
    <div>MyChoice</div>
  )
}
